import { Tag } from 'components/Tag';
import { TagColorWithIntensity } from 'styles/userConstants';
import { Color } from 'types/colors';
import { Plan } from 'types/plan';

function convertOldPricingColor(color: Color): TagColorWithIntensity {
  if (color === 'blue-600') {
    return 'violine-supershy';
  }
  if (color === 'amber-600') {
    return 'aloe-vera-supershy';
  }
  return 'gris-quiet';
}

export function PlanTag({ plan }: { plan: Plan }) {
  return (
    <Tag
      color={convertOldPricingColor(plan?.color || 'amber-50')}
      id="tier-standard"
    >
      {plan.label}
    </Tag>
  );
}
